export default __webpack_public_path__ + "static/media/suraj-karambe.d1fa8608.png";